import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

interface MetaProviderProps {
    children: ReactNode;
}

const MetaProvider: FC<MetaProviderProps> = ({ children }): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <>
            <Helmet>
                <meta
                    property='og:image'
                    content='https://user-images.githubusercontent.com/31943923/226115076-96e03ac1-4116-422b-8d0f-254c45718cc0.png'
                />
            </Helmet>
            {children}
        </>
    );
};

export default MetaProvider;
